// extracted by mini-css-extract-plugin
export var modal = "_sh-0";
export var table = "_sh-1";